import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/28_mountain_lake/28_mountain_lake"
 * Contains 1 texture(s)
 */
export class Tablet28MountainLakeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/28_mountain_lake/28_mountain_lake';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '28_mountain_lake.jpg'
    ] as const;
}
